import { GalleryContext, Image, Lentils } from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { arrowLeft, arrowRight } from '../sections/escuela-gallery';

const GalleryNavContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;

	button[data-type='arrow'] {
		background: none;
		border: none;
		aspect-ratio: 1 / 1;
		transition:
			transform 0.1s,
			opacity 0.2s;

		&:not(:disabled) {
			cursor: pointer;
		}

		&:disabled {
			cursor: default;
			opacity: 0.3;
		}

		&:not(:disabled):hover {
			transform: scale(0.8);
		}
	}
`;

export const GalleryNav = (): React.ReactElement | null => {
	const gallery = React.useContext(GalleryContext);
	if (!gallery) return null;
	const { index, length, endlessScrolling, triggerChange } = gallery;

	const isPrevDisabled = !endlessScrolling && index === 0;
	const isNextDisabled = !endlessScrolling && index === length - 1;

	const handleChange = (index: number) => {
		triggerChange?.(index);
	};

	return (
		<GalleryNavContainer>
			<button
				onClick={() => (!isPrevDisabled && handleChange(index - 1)) || null}
				disabled={isPrevDisabled}
				data-type="arrow"
				aria-label="Anterior"
			>
				<Image src={arrowLeft} alt="Anterior" />
			</button>

			<Lentils />

			<button
				onClick={() => (!isNextDisabled && handleChange(index + 1)) || null}
				disabled={isNextDisabled}
				data-type="arrow"
				aria-label="Siguiente"
			>
				<Image src={arrowRight} alt="Siguiente" />
			</button>
		</GalleryNavContainer>
	);
};
